import './index.css'

import Footer from '../Footer'

const About = () => (
  <div className="about-container-last">
    <div className="about-image-container-last">
      <h1 className="about-heading3">
        We integrate strategy, design, and engineering
      </h1>
      <p className="paragraph-about">
        Enabling global enterprises and tech disruptors to become modern digital
        businesses
      </p>
    </div>
    <h1 className="history">Our History</h1>
    <p className="paragraph-about-last">
      AMRUTHA SYSTEMS Pvt Ltd is a custom software development company and offer
      complete cycle of customized software programming services that include
      offshore web development, product ideas, enhancement and support.
      <br /> At AMRUTHA SYSTEMS, we employ a large pool of talented and eligible
      engineers who come from different backgrounds having well balanced
      knowledge of current demands.
      <br /> Our Custom Software Developments include techniques and programs
      like .NET Programming / Java, application re-engineering, PHP, software
      re- factoring. Internet/Intranet web design services include services like
      CRM, Client/Server application development, Web development and Knowledge
      Management systems. <br />
      Offshore Web Development caters to offshore project according to
      customer’s needs and business goals.
    </p>
    <Footer />
  </div>
)
export default About
